/* eslint-disable */
/**
 * [TODO] Acted in 2021: We don't support IE anymore.
 * Are those necessary anymore ?
 */
// Modernizr style test
if (!(window.webkitMatchMedia || window.mozMatchMedia || window.oMatchMedia || window.msMatchMedia || window.matchMedia)) {
  var root = document.getElementsByTagName('html')[0]
  root.className += ' no-matchmedia'
}

if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
}

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license */
window.matchMedia || (window.matchMedia = (function () {
  'use strict'

    // For browsers that support matchMedium api such as IE 9 and webkit
  var styleMedia = (window.styleMedia || window.media)

    // For those that don't support matchMedium
  if (!styleMedia) {
    var style = document.createElement('style'),
      script = document.getElementsByTagName('script')[0],
      info = null

    style.type = 'text/css'
    style.id = 'matchmediajs-test'

    script.parentNode.insertBefore(style, script)

        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
    info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle

    styleMedia = {
      matchMedium: function (media) {
        var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }'

                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
        if (style.styleSheet) {
          style.styleSheet.cssText = text
        } else {
          style.textContent = text
        }

                // Test if media query is true or false
        return info.width === '1px'
      }
    }
  }

  return function (media) {
    return {
      matches: styleMedia.matchMedium(media || 'all'),
      media: media || 'all'
    }
  }
}()));

/*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. Dual MIT/BSD license */
(function () {
    // Bail out for browsers that have addListener support
  if (window.matchMedia && window.matchMedia('all').addListener) {
    return false
  }

  var localMatchMedia = window.matchMedia,
    hasMediaQueries = localMatchMedia('only all').matches,
    isListening = false,
    timeoutID = 0,    // setTimeout for debouncing 'handleChange'
    queries = [],   // Contains each 'mql' and associated 'listeners' if 'addListener' is used
    handleChange = function (evt) {
            // Debounce
      clearTimeout(timeoutID)

      timeoutID = setTimeout(function () {
        for (var i = 0, il = queries.length; i < il; i++) {
          var mql = queries[i].mql,
            listeners = queries[i].listeners || [],
            matches = localMatchMedia(mql.media).matches

                    // Update mql.matches value and call listeners
                    // Fire listeners only if transitioning to or from matched state
          if (matches !== mql.matches) {
            mql.matches = matches

            for (var j = 0, jl = listeners.length; j < jl; j++) {
              listeners[j].call(window, mql)
            }
          }
        }
      }, 30)
    }

  window.matchMedia = function (media) {
    var mql = localMatchMedia(media),
      listeners = [],
      index = 0

    mql.addListener = function (listener) {
            // Changes would not occur to css media type so return now (Affects IE <= 8)
      if (!hasMediaQueries) {
        return
      }

            // Set up 'resize' listener for browsers that support CSS3 media queries (Not for IE <= 8)
            // There should only ever be 1 resize listener running for performance
      if (!isListening) {
        isListening = true
        window.addEventListener('resize', handleChange, true)
      }

            // Push object only if it has not been pushed already
      if (index === 0) {
        index = queries.push({
          mql: mql,
          listeners: listeners
        })
      }

      listeners.push(listener)
    }

    mql.removeListener = function (listener) {
      for (var i = 0, il = listeners.length; i < il; i++) {
        if (listeners[i] === listener) {
          listeners.splice(i, 1)
        }
      }
    }

    return mql
  }
}())

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function (predicate) {
       // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }

      var o = Object(this)

        // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function')
      }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1]

        // 5. Let k be 0.
      var k = 0

        // 6. Repeat, while k < len
      while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return kValue.
        var kValue = o[k]
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue
        }
          // e. Increase k by 1.
        k++
      }

        // 7. Return undefined.
      return undefined
    }
  })
}

  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function (predicate) {
       // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }

      var o = Object(this)

        // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function')
      }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1]

        // 5. Let k be 0.
      var k = 0

        // 6. Repeat, while k < len
      while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return k.
        var kValue = o[k]
        if (predicate.call(thisArg, kValue, k, o)) {
          return k
        }
          // e. Increase k by 1.
        k++
      }

        // 7. Return -1.
      return -1
    }
  })
}

  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function (searchElement, fromIndex) {
        // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }

      var o = Object(this)

        // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0

        // 3. If len is 0, return false.
      if (len === 0) {
        return false
      }

        // 4. Let n be ? ToInteger(fromIndex).
        //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0

        // 5. If n ≥ 0, then
        //  a. Let k be n.
        // 6. Else n < 0,
        //  a. Let k be len + n.
        //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0)

        // 7. Repeat, while k < len
      while (k < len) {
          // a. Let elementK be the result of ? Get(O, ! ToString(k)).
          // b. If SameValueZero(searchElement, elementK) is true, return true.
          // c. Increase k by 1.
          // NOTE: === provides the correct "SameValueZero" comparison needed here.
        if (o[k] === searchElement) {
          return true
        }
        k++
      }

        // 8. Return false
      return false
    }
  })
}

if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict'
    if (typeof start !== 'number') {
      start = 0
    }

    if (start + search.length > this.length) {
      return false
    } else {
      return this.indexOf(search, start) !== -1
    }
  }
}

(function (self) {
  'use strict'

  var nativeURLSearchParams = self.URLSearchParams ? self.URLSearchParams : null,
    isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
    __URLSearchParams__ = '__URLSearchParams__',
    prototype = URLSearchParamsPolyfill.prototype,
    iterable = !!(self.Symbol && self.Symbol.iterator)

  if (nativeURLSearchParams && isSupportObjectConstructor) {
    return
  }

    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
  function URLSearchParamsPolyfill (search) {
    search = search || ''

        // support construct object with another URLSearchParams instance
    if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
      search = search.toString()
    }

    this[__URLSearchParams__] = parseToDict(search)
  }

    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
  prototype.append = function (name, value) {
    appendTo(this[__URLSearchParams__], name, value)
  }

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
  prototype.delete = function (name) {
    delete this[__URLSearchParams__][name]
  }

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
  prototype.get = function (name) {
    var dict = this[__URLSearchParams__]
    return name in dict ? dict[name][0] : null
  }

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
  prototype.getAll = function (name) {
    var dict = this[__URLSearchParams__]
    return name in dict ? dict[name].slice(0) : []
  }

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
  prototype.has = function (name) {
    return name in this[__URLSearchParams__]
  }

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
  prototype.set = function set (name, value) {
    this[__URLSearchParams__][name] = ['' + value]
  }

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
  prototype.toString = function () {
    var dict = this[__URLSearchParams__], query = [], i, key, name, value
    for (key in dict) {
      name = encode(key)
      for (i = 0, value = dict[key]; i < value.length; i++) {
        query.push(name + '=' + encode(value[i]))
      }
    }
    return query.join('&')
  }

    /*
     * Apply polifill to global object and append other prototype into it
     */
  self.URLSearchParams = (nativeURLSearchParams && !isSupportObjectConstructor)
        ? new Proxy(nativeURLSearchParams, {
          construct: function (target, args) {
            return new target((new URLSearchParamsPolyfill(args[0]).toString()))
          }
        })
        : URLSearchParamsPolyfill

  var USPProto = self.URLSearchParams.prototype

  USPProto.polyfill = true

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
  USPProto.forEach = USPProto.forEach || function (callback, thisArg) {
    var dict = parseToDict(this.toString())
    Object.getOwnPropertyNames(dict).forEach(function (name) {
      dict[name].forEach(function (value) {
        callback.call(thisArg, value, name, this)
      }, this)
    }, this)
  }

    /**
     * Sort all name-value pairs
     */
  USPProto.sort = USPProto.sort || function () {
    var dict = parseToDict(this.toString()), keys = [], k, i, j
    for (k in dict) {
      keys.push(k)
    }
    keys.sort()

    for (i = 0; i < keys.length; i++) {
      this.delete(keys[i])
    }
    for (i = 0; i < keys.length; i++) {
      var key = keys[i], values = dict[key]
      for (j = 0; j < values.length; j++) {
        this.append(key, values[j])
      }
    }
  }

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
  USPProto.keys = USPProto.keys || function () {
    var items = []
    this.forEach(function (item, name) {
      items.push([name])
    })
    return makeIterator(items)
  }

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
  USPProto.values = USPProto.values || function () {
    var items = []
    this.forEach(function (item) {
      items.push([item])
    })
    return makeIterator(items)
  }

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
  USPProto.entries = USPProto.entries || function () {
    var items = []
    this.forEach(function (item, name) {
      items.push([name, item])
    })
    return makeIterator(items)
  }

  if (iterable) {
    USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries
  }

  function encode (str) {
    var replace = {
      '!': '%21',
      "'": '%27',
      '(': '%28',
      ')': '%29',
      '~': '%7E',
      '%20': '+',
      '%00': '\x00'
    }
    return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function (match) {
      return replace[match]
    })
  }

  function decode (str) {
    return decodeURIComponent(str.replace(/\+/g, ' '))
  }

  function makeIterator (arr) {
    var iterator = {
      next: function () {
        var value = arr.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (iterable) {
      iterator[self.Symbol.iterator] = function () {
        return iterator
      }
    }

    return iterator
  }

  function parseToDict (search) {
    var dict = {}

    if (typeof search === 'object') {
      for (var i in search) {
        if (search.hasOwnProperty(i)) {
          var str = typeof search[i] === 'string' ? search[i] : JSON.stringify(search[i])
          appendTo(dict, i, str)
        }
      }
    } else {
            // remove first '?'
      if (search.indexOf('?') === 0) {
        search = search.slice(1)
      }

      var pairs = search.split('&')
      for (var j = 0; j < pairs.length; j++) {
        var value = pairs[j],
          index = value.indexOf('=')

        if (index > -1) {
          appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)))
        } else {
          if (value) {
            appendTo(dict, decode(value), '')
          }
        }
      }
    }

    return dict
  }

  function appendTo (dict, name, value) {
    if (name in dict) {
      dict[name].push('' + value)
    } else {
      dict[name] = ['' + value]
    }
  }
})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this))



// WEBPACK FOOTER //
// ./src/utilities/polyfills.js